<template>
  <div style="width: 100%;" ref="circlewrapper" v-resize="onResize">
    <div
      class="chart"
      :style="`
        --percentageRotate: ${value > 100 ? 100 : value};
        --borderRadius: ${width}px;
        --borderWidth: ${borderWidth}px;
        height: ${height}px;
        width: ${width}px;
      `">
      <div :class="colorclass"></div>
      <span style="display: block; text-align: center;">
        <span :style="`font-size: ${valueSize}`" class="titlecolor--text">
          {{ value }}{{ valueSuffix }}
        </span>
        <span
          class="subtitlecolor--text text-uppercase d-block"
          :style="`font-Size: ${titleSize};`"
        >
          {{ title }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SemiProgressCircle',
  props: {
    scale: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '',
    },
    titleSize: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: 0,
    },
    valueSize: {
      type: String,
      default: '',
    },
    valueSuffix: {
      type: String,
      default: '',
    },
    borderWidth: {
      type: Number,
      default: 20,
    },
    loading: {
      type: Boolean,
    },
    colorclass: {
      type: String,
    },
  },
  data() {
    return {
      height: 0,
      width: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.onResize();
    });
  },
  watch: {
    scale() {
      this.onResize();
    },
    loading() {
      this.onResize();
    },
  },
  methods: {
    onResize() {
      const wrapper = this.$refs.circlewrapper;
      if (!wrapper || !wrapper.clientWidth) {
        return;
      }

      const width = wrapper.clientWidth;
      const height = width / 2;
      this.$nextTick(() => {
        this.width = width;
        this.height = height + 1;
      });
    },
  },
};
</script>
<style>
.red-chart {
  border-color: #ED5353 !important;
}
.yellow-chart {
  border-color: #FFDA6B !important;
}
.green-chart {
  border-color: #21CE99 !important;
}
.chart {
  padding: 0;
  margin: 0 auto;
  text-align: left;
  position: relative;
  list-style-type: none;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.chart *,
.chart::before {
  box-sizing: border-box;
}
.chart::before,
.chart::after {
  position: absolute;
}
.chart::before {
  content: '';
  width: inherit;
  height: inherit;
  border: var(--borderWidth) solid #21262E;
  border-bottom: none;
  border-top-left-radius: var(--borderRadius);
  border-top-right-radius: var(--borderRadius);
}
.chart div {
  position: absolute;
  top: 100%;
  left: 0;
  width: inherit;
  height: inherit;
  border: var(--borderWidth) solid #aeaeae;
  border-top: none;
  border-bottom-left-radius: var(--borderRadius);
  border-bottom-right-radius: var(--borderRadius);
  transform-origin: 50% 0;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  animation-fill-mode: forwards;
  animation-duration: .1s;
  animation-timing-function: linear;
}
.chart div:nth-child(1) {
  z-index: 4;
  border-color: #21C77C;
  transition: all 0.3s;
  transform: rotate(calc(var(--percentageRotate) * 1.8deg));
}
.chart span {
  font-size: 18px;
  backface-visibility: hidden;
  color: white;
  animation: fade-in .1s linear forwards;
}
.chart .candidate-one-percentage {
  top: 10px;
  left: -35px;
  transform: rotate(-90deg);
}
.chart .candidate-two-percentage {
  top: -35px;
  left: -35px;
  transform: rotate(-90deg);
}
@keyframes rotate-one {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(calc(var(--percentageRotate) * 1.8deg));
  }
}
</style>
